/**
 * Remove the share of the worksite only if the user is admin or the creator.
 * If not return false otherwise return the removing function
 * @param {Object} params
 * @param {Object} params.user - The user to remove sharing from
 * @param {Object} params.selectedWorksite - The selected worksite
 * @param {Object} params.countryApiRequest - The API request utility
 * @param {Function} params.push - The notification push function
 * @param {Object} params.intl - The intl object for translations
 * @param {Object} params.userData - The current user data
 * @param {Object} params.history - The router history object
 * @param {Object} params.country - The country object
 * @param {Array} params.showSharing - Current sharing list
 * @param {Function} params.setShowSharing - Function to update sharing list
 * @param {Function} params.fetchSharing - Function to fetch updated sharing
 * @returns {Promise<void>}
 */
export const removeSharing = async ({
  user,
  selectedWorksite,
  countryApiRequest,
  push,
  intl,
  userData,
  history,
  country,
  showSharing,
  setShowSharing,
  fetchSharing,
}) => {
  try {
    const payload = {
      worksite_id: selectedWorksite.id,
      to_user_id: user["id"],
      hierarchy: user["role_hierarchy"],
    };
    const { message } = await countryApiRequest.post("/share/remove", payload);
    if (message === "already_removed") {
      push({
        title: intl.formatMessage({ id: "share_already_removed" }),
        type: "error",
      });
    } else {
      push({
        title: intl.formatMessage({
          id: "share_removed_success",
          defaultMessage: "Condivisione rimossa",
        }),
        type: "success",
      });
    }
    if (userData.role_type !== "admin" && ![userData.id, userData.account_user_id].includes(selectedWorksite.id_creator)) {
      // if the user is not admin and not creator
      // redirect to worksites list because the user shouldn't have access to the worksite anymore
      history.push(`/${country.code}/worksites`);
    } else {
      // Condition to refresh worksite sharing information
      setShowSharing(showSharing.filter(el => el.id !== user.id))
      await fetchSharing();
    }
  } catch (e) {
    push({
      title: intl.formatMessage({ id: "server_error" }),
      type: "error",
    });
    console.error(e);
  }
};

